import { useLayoutEffect } from 'react';

import fetcher from 'api/fetcher';
import { SETTINGS_LIST, SettingsConfig } from 'utils/constants/dynamicSettings';
import { Methods } from 'utils/constants/methods';

import { setDynamicSettings } from 'store/autoReducers';
import { Action } from 'store/createReducer';
import { setAllTranslations } from 'store/models/translations';
import { useDispatch, useSelector } from 'store/utils';

// todo error handling
export const useRequiredDataDownload = (): boolean => {
    const user = useSelector((state) => state.user.user);
    const trls = useSelector((state) => state.translations.trls);
    const dynamicSettings = useSelector((state) => state.dynamicSettings);
    const needTranslations = Object.keys(trls).length === 0;
    const needSettings = user && Object.keys(dynamicSettings).length === 0 && SETTINGS_LIST.length !== 0;
    const haveToDownload = needSettings || needTranslations;
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        if (haveToDownload) {
            void Promise.all([
                needTranslations ? fetcher.get<unknown, Record<string, string>>(Methods.Translations) : null,
                needSettings ? fetcher.get<unknown, Partial<SettingsConfig>>(Methods.Settings) : null,
            ]).then(([translations, settings]) => {
                const actions: Action[] = [];

                if (translations) actions.push(setAllTranslations(translations));
                if (settings) actions.push(setDynamicSettings(settings));

                dispatch(actions);
            });
        }
    }, [dispatch, haveToDownload, needTranslations, needSettings]);

    return haveToDownload;
};
